<template>
  <div class="wd-100p ht-100p">
    <Header></Header>
    <div class="wd-100p ht-100p cr-hei">
      <div class="wd-100p ht-70"></div>
      <div class="wd-100p ht-100p-70 pos-r">
        <!-- <mv-full-page
          :isPointer="false"
          height="100%"
          position="relative"
          pointerPos="right"
          :isV="isV"
          :pages="pages"
          :page.sync="page"
          :bgArr="bgArr"
          :isCache="true"
          :transition="{
            duration: '700ms', // 动画时长
            timingFun: 'ease', // 动画速度曲线
            delay: '0s', // 动画延迟
          }"
          @rollEnd="onRollEnd"
          :config="config"
          @pointerMouseover="pointerMouseover"
        > -->
          <!-- 动态插槽 -->
          <!-- <template v-slot:[dynamicSlotName+page] v-for="page in pages">
            <div :class="`page${page}`" :key="page">
              {{ `页面${page}` }}
            </div>
          </template> -->
          <!-- 静态插槽 -->
          <!-- <template #page1> -->
            <div class="wd-100p ht-100p bg-1">
              <div class="ht-100p pos-r ov-h ov-a-y bg-2" v-animate="{ name: 'bounceInLeft', delay: 0}">
                <div class="wd-100p bg-2">
                    <div class="max-wd-1440 dp-flex jus-c ht-60 mg-a font-24 fw">ROOM TYPES</div>
                    <div class="max-wd-1440 mg-a pd-20" v-for="(n,j) in virtualList" :key="j">
                        <div class="font-20 fw">{{n.title}}</div>
                        <Row :gutter="20">
                        <Col  :xs="12" :sm="8" v-for="(item,i) in n.list" :key="i">
                            <div class="wd-100p pd-t-30 pointer"  @click="tiggerVirtual(item)" v-animate="{ name: 'bounceInLeft', delay: 100 * i }">
                              <div class="wd-100p dp-flex jus-c">
                                  <img class="wd-90p" :src="require('@/assets/virtual/' + item.img)" /> 
                              </div>
                              <div class="ht-60 txt-ali-c dp-flex jus-c Roboto s-name">{{item.name}}</div>
                            </div>
                        </Col>
                        </Row>
                    </div>
                </div>
                <div class="wd-100p pd-40 bg-white">
                    <div class="max-wd-1440 mg-a pd-20 pointer" @click="tiggerVirtual()">
                        <img class="wd-100p" :src="require('@/assets/virtual/banner.jpg')" />
                    </div>
                </div>
                <div class="wd-100p pd-40">
                    <div class="max-wd-1440 mg-a pd-20 txt-ali-c">
                        <h1 class="h1 font-40">Elevated Luxury in a Prime Location Meets <br> Vietnamese Hospitality</h1>
                        <div class="max-wd-800 mg-a font-1vw">
                          <p class="mg-t-20">From its vantage point overlooking the scenic West Lake, Fraser Suites' 
                          Hanoi serviced apartments offer business and leisure travellers the best of 
                          both worlds: a fantastic hotel location in the heart of the city, and a safe, 
                          soothing respite from Hanoi's chaotic streets.
                          </p>
                        </div>
                        <div class="max-wd-800 mg-a font-1vw" v-if="more">
                          <p> <br>
  The apartments in Hanoi are located in highly secure, prestigious premises including a rooftop pool and bar at Syrena Tower on Xuan Dieu Street. They sit in a sought-after residential enclave that’s just a short drive to the Old Quarter - where you’ll discover the rich, colonial heritage of this bustling city.</p>
<p>Your search for hotel apartments in Hanoi ends at Fraser Suites Hanoi - a safe haven of 280 Gold Standard fully furnished residences ranging from studios to luxurious duplexes. The imposing skyscraper with its rooftop pool and bar in the famed Tay Ho (West Lake) district boasts unparalleled views of Hanoi’s largest freshwater lake and surrounding gardens.</p>
<p> <br>
  Experience Gold Standard hospitality with its award-winning service, spacious elegant interiors, and comprehensive facilities. Among Hanoi serviced apartments, Fraser Suites Hanoi has stringent security measures in place so you can feel safe as you explore the neighbourhood and fully experience how the Tay Ho district evolved from its sleepy fishing village past to the thriving lifestyle and dining hub it is today.</p>
<p> <br>
  Fraser Suites Hanoi is just steps away from shopping malls, restaurants, supermarkets and medical facilities. Within the same compound is the famed Syrena Shopping Centre, where you can spend hours browsing through myriad shops, cafes, restaurants, and gourmet markets. If you’re in town for business, Fraser Suites Hanoi’s customisable boardroom and meeting facilities are complemented with secretarial support services for a successful event. After work or a hectic day of sightseeing, unwind in your own Hanoi luxury apartment as you enjoy the gorgeous views of the city skyline. With all the modern conveniences from high-speed Wi-Fi to 24/7 gym facilities, spa and childcare services, Fraser Suites makes sure you’re taken care of at their Hanoi serviced apartments.</p>

                        </div>
                        <p class="crb2 font-22 fw mg-t-30 pointer" v-else @click="readMore">READ MORE</p>
                    </div>
                </div>
                <div class="wd-100p pd-40 bg-3">
                    <div class="max-wd-1440 mg-a pd-20">
                      <Row :gutter="12">
                        <Col :xs="24" :sm="12">
                          <div class="dp-flex ht-100p pd-b-20">
                            <div class="crb2 Roboto font-16">
                                Getting here<br>
                                <h1 class="Cormorant cr-hei">Fraser Suites Hanoi</h1><br>
                                51 Xuan Dieu Street, Quang An, Tay Ho District, Hanoi, Vietnam<br><br>
                                <span class="cr-hei Roboto">Tel: </span>+84 24 3719 8877<br>
                                <span class="cr-hei Roboto">Email: </span>sales.hanoi@frasershospitality.com<br><br>
                                <hr>
                                <div class="dp-flex Roboto pd-t-20">
                                  <img :src="require('@/assets/virtual/icon_plane.png')" class="mg-r5"> Airport transfer is available on request
                                </div>
                            </div>
                            <div class="fx-1"></div>
                          </div>
                        </Col>
                        <Col :xs="24" :sm="12">
                        <div class="dp-flex jus-e">
                          <!-- <img class="wd-100p max-wd-500" :src="require('@/assets/virtual/map.jpg')"> -->
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.216788397095!2d105.82540831493328!3d21.0640019859793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3135abec9cafe74f%3A0x1bb14cdd847bf57c!2sFraser%20Suites%20Hanoi!5e0!3m2!1sen!2ssg!4v1642730970674!5m2!1sen!2ssg" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
                        </div>
                        </Col>
                      </Row>
                    </div>
                </div>

              <Footer  v-animate="{ name: 'bounceInLeft', delay: 600}"/>
            </div>
            </div>
          <!-- </template>
        </mv-full-page> -->
        <div v-if="showVirtual" id="showVirtual" class="pos-a top-0 left-0 wd-100p ht-100p zindex-9 bg-white">
            <div class="pos-a top-0 right-0 bg-hei-06 dp-flex jus-c wd-40 ht-40 pointer" @click="tiggerVirtual"><img :src="require('@/assets/close.png')"/></div>
            <iframe  v-if="linkVirtual" class="wd-100p ht-100p" :src="linkVirtual" frameborder="0" allow="" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MvFullPage from "@/components/MvFullPage/index.vue";
import Header from "@/components/header.vue";
import config from "@/config";
import Footer from "@/components/footer.vue";

export default {
  components: { MvFullPage, Header,Footer },
  data() {
    return {
      virtualList:[],
      linkVirtual: null,
      showVirtual:false,
      more:false,
      dynamicSlotName: "page",
      pages: 1, // 页面总数
      tempPage: 1,
      isV: true, //滚动的方向 true 为垂直方向，false 为左右方向
      page: 1, // 当前页面
      bgArr: [],
      config: {
        // 自动播放
        autoPlay: false,
        //  循环播放
        loop: false,
        // 切换间隔
        interval: 1000,
        // 上一页箭头
        lastArrow: false,
        // 下一页箭头
        nextArrow: false,
      },
    };
  },
  methods: {
    pointerMouseover({ event, index }) {
      console.log(event, index);
    },
    onRollEnd(page) {
      // console.log("当前页面为", page);
    },
    toPage() {
      this.page = this.tempPage;
    },
    clickref(ref) {
      this.pushr(ref);
    },
    tiggerVirtual(item){
      this.showVirtual = !this.showVirtual;
      if (!item) {
        item = {
          link: "./fraser-suite-hanoi-20221125/index.htm",
        };
      }
      if(this.showVirtual){
        this.linkVirtual = item.link;
      }else{
        this.linkVirtual = null;
      }
    },
    readMore(){
      this.more = !this.more;
    },
  },
  created() {
    this.virtualList = config.virtualList;
  },
  mounted() {    
    this.$store.dispatch("getMob");
  },
  computed: {
    virtualLink(){
      return this.$store.state.virtualLink;
    }
  },
  watch:{
    virtualLink(val){
      this.showVirtual = false;
      this.tiggerVirtual(val);
    }
  },
  beforeDestroy() {},
};
</script>
<style>
.s-name{
  font-size: 22px;
}
@media (max-width: 900px) { 
  .pd-t-30{
    padding-top: 10px;
  }
  .wd-220{
    width: 120px;
  }
  .ht-150{
    height: 110px;
  }
  .s-name{
    font-size: 14px;
  }
  .pd-40{
    padding:0px
  }
  .font-40{
    font-size:8vw;
  }
  .font-1vw{
    font-size:4.8vw;
  }
  .font-22{
    font-size:5.8vw;
  }
  .ft-s14{
    font-size:10px;
  }
}
@media (min-width: 376px) { 
  .ivu-col-span-sm-4-8{
    flex: 0 0 20%;
    max-width: 20%;
  }

}
</style>